/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  AccessControlLogic,
  AccessControlLogicInterface,
} from "../../../../contracts/dependant/accessControl/AccessControlLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isPrivileged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegedList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type AccessControlLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AccessControlLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AccessControlLogic__factory extends ContractFactory {
  constructor(...args: AccessControlLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<AccessControlLogic> {
    return super.deploy(overrides || {}) as Promise<AccessControlLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): AccessControlLogic {
    return super.attach(address) as AccessControlLogic;
  }
  override connect(signer: Signer): AccessControlLogic__factory {
    return super.connect(signer) as AccessControlLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AccessControlLogicInterface {
    return new utils.Interface(_abi) as AccessControlLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AccessControlLogic {
    return new Contract(address, _abi, signerOrProvider) as AccessControlLogic;
  }
}
